/* import __COLOCATED_TEMPLATE__ from './diagnosis-value.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class SiteDocumentsNoteDiagnosisTreatmentPlanDiagnosisValue extends Component {}
